import React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import LoginForm from "../components/auth/LoginForm"

export default function LoginPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || "/panel"

  return (
    <main className="max-w-7xl mx-auto px-4 py-8">
      <LoginForm onSuccess={() => navigate(from, { replace: true })} />
    </main>
  )
}
